class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinkDesktop = document.querySelector('#cart-icon-bubble');
    const cartLinkTablet = document.querySelector('#cart-icon-bubble-tablet');
  
    [cartLinkDesktop, cartLinkTablet].forEach(cartLink => {
      if (cartLink) {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.getSectionsToRender().forEach((section) => {

        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        
        // Check if the sectionElement is found before proceeding
        if (sectionElement) {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } else {
            console.error(`Element not found for selector: ${section.selector}`);
        }
    });

    setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
        if (typeof initPromoSlider === 'function') {
          initPromoSlider();
        }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// Function to add item to the cart
function addItemToCart(variantID) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('is-loading');
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    body: JSON.stringify({
      id: variantID,
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
    }),
  })
    .then((response) => response.json())
    .then((response) => {
      const state = {
        sections: {
          'cart-drawer': response.sections['cart-drawer'],
          'cart-icon-bubble': response.sections['cart-icon-bubble'],
        },
      };

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      const errorMessage = document.querySelector('.cart-error-message');
      if (errorMessage) {
        errorMessage.textContent = window.customStrings?.cart_update_error || '';
        errorMessage.style.display = 'block';
      }
    })
    .finally(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-loading');
      }
    });
}

// Function to remove item from the cart
function removeItemFromCart(variantID) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('is-loading');
  }

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const line = cart.items.findIndex((item) => item.variant_id === variantID) + 1;

      if (line === 0) {
        throw new Error('Item not found in cart');
      }

      const body = JSON.stringify({
        line: line.toString(),
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
      });

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body,
      });
    })
    .then((response) => response.json())
    .then((response) => {
      const state = {
        sections: {
          'cart-drawer': response.sections['cart-drawer'],
          'cart-icon-bubble': response.sections['cart-icon-bubble'],
        },
      };

      if (cartDrawer) {
        cartDrawer.renderContents(state);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      const errorMessage = document.querySelector('.cart-error-message');
      if (errorMessage) {
        errorMessage.textContent = window.customStrings?.cart_update_error || '';
        errorMessage.style.display = 'block';
      }
    })
    .finally(() => {
      if (cartDrawer) {
        cartDrawer.classList.remove('is-loading');
      }
    });
}

// Main function to handle checkbox change
function handleCheckboxChange(checkbox) {
  const variantID = 47121363960152;

  if (checkbox.checked) {
    // If checkbox is checked, add the item to the cart
    addItemToCart(variantID);
  } else {
    // If checkbox is unchecked, remove the item from the cart
    removeItemFromCart(variantID);
  }
}
document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
      document.querySelector('#cart').submit();
    });
  });
var threshold = {
  "19 €": 24500,
  "23 €": 24500,
  "9 €": 9800,
  " ": 27500,
  "": 27500
}

const drawer = document.getElementById('CartDrawer');
  
// Create a function to update the shipping cost
function modifyDrawerContent() {
  const localData = JSON.parse(localStorage.getItem('themeData'));
  const shippingCostElement = document.querySelector('#shippingCost');
  const totalCartDiv = document.querySelector('#totalCartAdded');
  const totalCartElement = document.querySelector('p[data-total]');
  
  // Verificar que los elementos necesarios existan
  if (!totalCartDiv || !totalCartElement) {
    return;
  }

  const currencySymbol = window.customStrings?.currency_symbol || '';
  const freeLabel = window.customStrings?.free_label || '';
  const totalCart = parseFloat(totalCartElement.getAttribute('data-total'));
  
  if (shippingCostElement != null && localData) {
    if (totalCart >= threshold[localData.shippingCost]) {
      shippingCostElement.textContent = freeLabel;
      totalCartDiv.textContent = currencySymbol + (parseFloat(totalCartElement.getAttribute('data-total')) / 100);
    } else {
      shippingCostElement.textContent = currencySymbol + localData.shippingCost.replace(/\s+€$/, "");

      var shippingCost = parseFloat(localData.shippingCost);
      var cartTotal = parseFloat(totalCart) / 100;
      var totalWithShipping = shippingCost + cartTotal;

      // Update the totalCartDiv with the calculated total
      totalCartDiv.textContent = currencySymbol + totalWithShipping;
    }
  } else if (totalCartDiv && totalCartElement) {
    // Si no hay shippingCostElement, al menos mostrar el total del carrito
    totalCartDiv.textContent = currencySymbol + (parseFloat(totalCartElement.getAttribute('data-total')) / 100);
  }
}
const observer = new MutationObserver(function(mutationsList, observer) {
  // Temporarily disconnect the observer to prevent recursive calls
  observer.disconnect();

  // Call the updateShippingCost function whenever the content of the drawer changes
  modifyDrawerContent();

  // Reconnect the observer to resume observing
  observer.observe(drawer, { childList: true, subtree: true });
});

// Start observing changes in the drawer content
if (drawer) {
  observer.observe(drawer, { childList: true, subtree: true });
}

// Run the updateShippingCost function initially to ensure the shipping cost is updated
modifyDrawerContent();
 
function toggleActiveClass() {
    const reviewDivs = document.querySelectorAll(".drawerReview .review");
    if (reviewDivs.length === 0) {
        // No review elements found, do nothing
        return;
    }

    let activeIndex = -1;

    // Find the index of the currently active review
    for (let i = 0; i < reviewDivs.length; i++) {
      if (reviewDivs[i].classList.contains("active")) {
        activeIndex = i;
        break;
      }
    }

    // Remove the active class from the currently active review
    if (activeIndex !== -1) {
      reviewDivs[activeIndex].classList.remove("active");
    }

    // Calculate the index of the next review to make active
    const nextIndex = (activeIndex + 1) % reviewDivs.length;

    // Add the active class to the next review
    reviewDivs[nextIndex].classList.add("active");
}
// Set the interval to call the function every 5 seconds (5000 milliseconds)
setInterval(toggleActiveClass, 5000);

//promo-slide
//promo-slide
function initPromoSlider() {
  const promoSlides = document.querySelectorAll('.promo-slide');
  if (promoSlides.length === 0) return;
  
  let currentSlide = 0;

  // Limpiar intervalo anterior si existe
  if (window.promoSliderInterval) {
    clearInterval(window.promoSliderInterval);
  }

  // Animación inicial
  setTimeout(() => {
    promoSlides[currentSlide].classList.add('active');
  }, 100);

  function rotatePromo() {
    promoSlides[currentSlide].classList.add('exit');
    
    setTimeout(() => {
      promoSlides[currentSlide].classList.remove('active', 'exit');
      currentSlide = (currentSlide + 1) % promoSlides.length;
      promoSlides[currentSlide].classList.add('active');
    }, 600);
  }

  window.promoSliderInterval = setInterval(rotatePromo, 6000);
}

// Ejecutar al cargar inicialmente
initPromoSlider();